import apiZelo from '../backAxiosVendaToken';

let retorno;

export const BuscarProduto = async () => {
    await apiZelo
        .get('/produtos')
        .then(responseJson => {
            if (responseJson) {
                retorno = responseJson.data;
            } else {
                retorno = { erro: 'parametros errados' };
            }
        })
        .catch(err => {
            retorno = err;
        });

    return await retorno;
};

export const getProducts = async (uf, city, typeProduct) => {
    try {
        const response = await apiZelo.get(
            `/associados/busca-preco-uf/${uf}/${city}/${typeProduct}`
        );

        return response;
    } catch (err) {
        return err;
    }
};

export const BuscarLocalidade = async () => {
    try {
        const { data } = await apiZelo.get('/vendedor/localidade');

        return data;
    } catch (error) {
        return error;
    }
};

export const BuscarProdutoBonificaco = async (subGrupo, cidade) => {
    try {
        const { data } = await apiZelo.get(`/produtoPreco/bonificacao?subGrupo=${subGrupo}&cidade=${cidade}`);

        return data;
    } catch (error) {
        return error;
    }
};
